import { AxiosResponse } from 'axios'

export const extractFileName = (contentDispositionValue: string) => {
  let filename = ''

  if (
    contentDispositionValue &&
    contentDispositionValue.indexOf('attachment') !== -1
  ) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const matches = filenameRegex.exec(contentDispositionValue)

    if (matches !== null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '')
    }
  }

  return filename
}

export const saveAs = (
  data: Blob,
  fileName: string,
  blobOptions?: BlobPropertyBag
) => {
  const url = window.URL.createObjectURL(new Blob([data], blobOptions))
  const link = document.createElement('a')

  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}

export const downloadApiResponse = (
  response: AxiosResponse<Blob>,
  blobOptions?: BlobPropertyBag
) => {
  saveAs(
    response.data,
    extractFileName(response.headers['content-disposition']),
    blobOptions
  )
}
